import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  Switch,
  FormControlLabel,
  Button,
  Alert,
  CircularProgress,
  InputAdornment,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import RefreshIcon from '@mui/icons-material/Refresh';
import BasicInfoTab from './UserManagementDialog/BasicInfoTab';
import ReportingDashboardTab from './UserManagementDialog/ReportingDashboardTab';
import UserPreferencesTab from './UserManagementDialog/UserPreferencesTab';
import { useTheme } from '@emotion/react';

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-management-tabpanel-${index}`}
      aria-labelledby={`user-management-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

const UserManagementDialog = ({ open, onClose, user, sponsorId, onUserUpdate }) => {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleClose = () => {
    setTabValue(0);
    onClose();
  };

  if (!user) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: theme.shadows[10],
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" fontWeight={600} color={theme.palette.text.primary}>
            User Management
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{
              color: theme.palette.grey[500],
              '&:hover': {
                backgroundColor: theme.palette.grey[100],
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant="body2" color={theme.palette.text.secondary} sx={{ mt: 0.5 }}>
          {user?.firstName} {user?.lastName} ({user?.email})
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ p: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="user management tabs">
            <Tab label="Basic Info" id="user-management-tab-0" aria-controls="user-management-tabpanel-0" />
            <Tab label="User Preferences" id="user-management-tab-1" aria-controls="user-management-tabpanel-1" />
            <Tab label="Reporting Dashboard" id="user-management-tab-2" aria-controls="user-management-tabpanel-2" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <BasicInfoTab user={user} sponsorId={sponsorId} onUserUpdate={onUserUpdate} />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <UserPreferencesTab user={user} onUserUpdate={onUserUpdate} />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <ReportingDashboardTab user={user} />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};

export default UserManagementDialog;

